import { render, staticRenderFns } from "./CInviewItem.vue?vue&type=template&id=916148f6&"
import script from "./CInviewItem.vue?vue&type=script&lang=ts&"
export * from "./CInviewItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports